import { stringToNumber } from 'utils/strings';

import Base from 'app/views/base';

import { List as ListView, Heading } from 'app/components/list/list';

import tmpl from './template';

export const buildHeadings = () => [
  new Heading({
    text: m => m.getPlanProductReadable(),
    display: 'Plan',
    xsSize: 3,
  }),
  new Heading({
    text: m => `${Number(m.get('plan_quantity_per_interval')).toLocaleString()} / ${m.get('plan_interval')}`,
    display: 'Quantity',
    xsSize: 3,
  }),
  new Heading({
    text: m => {
      const amountAfterDiscount = m.get('amount_after_discount');
      if (stringToNumber(amountAfterDiscount) === 0) {
        return m.get('amount');
      }
      return amountAfterDiscount;
    },
    display: 'Cost',
    xsSize: 3,
    smSize: 2,
  }),
  new Heading({
    text: m => m.get('status'),
    wrapperClass: m => (m ? 'monospace-font' : ''),
    display: 'Status',
    xsSize: 3,
    smSize: 2,
  }),
  new Heading({
    text: m => m.get('usage'),
    display: 'Usage This Period',
    smSize: 2,
    xsHidden: true,
  }),
];

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'subscriptions',

  initialize() {
    this.addSubview('subscriptionsList', '#subscriptions_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      wrapperClass: 'list-sm',
      noResultsMessage: 'You have no subscriptions.',
    }));

    this.collection.fetch({ reset: true });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/subscriptions/index.js